import type { ReactNode } from "react";

interface CostPageHeaderProps {
    actions?: ReactNode;
    badge?: ReactNode;
    description: ReactNode;
    icon: ReactNode;
    navigation: ReactNode;
    title: string;
}

export default function CostPageHeader({
    actions,
    badge,
    description,
    icon,
    navigation,
    title
}: CostPageHeaderProps) {
    return (
        <header className="cost-page-header">
            <div className="cost-page-header__row">
                <div className="cost-page-header__identity">
                    <span className="cost-page-header__icon">{icon}</span>
                    <div>
                        <div className="cost-page-header__title">
                            <h1>{title}</h1>
                            {badge}
                        </div>
                        <div className="cost-page-header__description">{description}</div>
                    </div>
                </div>
                <div
                    className={`cost-page-header__actions${actions ? "" : " cost-page-header__actions--empty"}`}
                    aria-hidden={!actions}
                >
                    {actions}
                </div>
            </div>
            <nav className="cost-page-header__navigation" aria-label="Cost sections">
                {navigation}
            </nav>
        </header>
    );
}
